var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.85714C2 6.38376 2.38376 6 2.85714 6L20.5714 6C21.0448 6 21.4286 6.38376 21.4286 6.85714C21.4286 7.33053 21.0448 7.71429 20.5714 7.71429L2.85714 7.71429C2.38376 7.71429 2 7.33053 2 6.85714Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.9978C2 11.5244 2.38376 11.1406 2.85714 11.1406L20.5714 11.1406C21.0448 11.1406 21.4286 11.5244 21.4286 11.9978C21.4286 12.4712 21.0448 12.8549 20.5714 12.8549L2.85714 12.8549C2.38376 12.8549 2 12.4712 2 11.9978Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 17.1462C2 16.6728 2.38376 16.2891 2.85714 16.2891L20.5714 16.2891C21.0448 16.2891 21.4286 16.6728 21.4286 17.1462C21.4286 17.6196 21.0448 18.0033 20.5714 18.0033L2.85714 18.0033C2.38376 18.0033 2 17.6196 2 17.1462Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expandIcon.0577ca105190686d089c715833dd4ffd.svg";
export { ForwardRef as ReactComponent };